import API from '../api'
import getUrl from './paths'

// export const getHierarchy = (millis) =>
// 	new Promise((resolve, reject) => {
// 		API.get(getUrl.getLeaderboardHierarchy, { millis })
// 			.then((response) => {
// 				resolve(response.data)
// 			})
// 			.catch((error) => {
// 				reject(error)
// 			})
// 	})

export const getHighestEnquiryWeight = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestEnquiryWeight, { userId, millis, subRole, platforms, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestMarginAndPercentage = ({ commodityId = null, userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestMarginAndPercentage, { millis, subRole, commodityId, userId, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestOrderWeight = ({ userId, commodityId = null, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestOrderWeight, { userId, commodityId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestRevenue = ({ userId, millis, platforms, subRole }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestRevenue, { userId, millis, removeDefault: true, platforms, subRole })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getTotalOverdue = ({ userId, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getTotalOverdue, { userId, subRole, platforms, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestDispatch = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestDispatch, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestSupplierQuotes = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestSupplierQuotes, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestQuoteConversion = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestQuoteConversion, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestOrderGivenQuotes = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestOrderGivenQuotes, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestUniqueSupplierQuoted = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestUniqueSupplierQuoted, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const getHighestNewSupplierOnboarded = ({ userId, millis, subRole, platforms }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getHighestNewSupplierOnboarded, { userId, millis, subRole, platforms })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})

// export const getSalesHierarchy = (millis) =>
// 	new Promise((resolve, reject) => {
// 		API.get(getUrl.getLeaderboardSalesHierarchy, { millis })
// 			.then((response) => {
// 				resolve(response.data)
// 			})
// 			.catch((err) => {
// 				reject(err)
// 			})
// 	})
